require('./editTransferInformation.scss')

module.exports = {
  template: require('./editTransferInformation.pug')()
  controller: require('./editTransferInformation.ctrl')
  bindings:
    salon: '<'
}
